export default "__VITE_ASSET__Cfo8nG8m__"